// State selectors
export const downloadingSelector = (state) => state.business.downloading;
